import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import * as GoogleMapMarker from '@angular/google-maps';
import {GoogleMap, MapInfoWindow} from '@angular/google-maps';
import {MapMarker} from './MapMarker';

@Component({
  selector: 'digires-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss']
})
export class GoogleMapComponent implements OnChanges {

  @ViewChild(GoogleMap) googleMap: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;

  @Input() center: google.maps.LatLng;
  @Input() zoom: number;
  @Input() markers: MapMarker[];
  @Input() boundaries: google.maps.LatLngBounds;

  @Output() zoomChanged = new EventEmitter<number>();
  @Output() centerChanged = new EventEmitter<google.maps.LatLng>();
  @Output() mapClicked = new EventEmitter<google.maps.LatLng>();
  @Output() markerClicked = new EventEmitter<MapMarker>();

  public readonly options: google.maps.MapOptions = {
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_CENTER
    },
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: true,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.TOP_LEFT
    },
    isFractionalZoomEnabled: true,
  };
  public infoContent: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.boundaries && !changes.boundaries.isFirstChange()) {
      const boundaries = changes.boundaries.currentValue;
      this.googleMap.fitBounds(boundaries);
      this.googleMap.panTo(new google.maps.LatLng(boundaries.getCenter().lat(), boundaries.getCenter().lng()));
    }
  }

  public onZoomChanged() {
    this.zoomChanged.emit(this.googleMap.getZoom());
  }

  public onMarkerClicked(marker: MapMarker) {
    this.markerClicked.emit(marker);
  }

  public onCenterChanged() {
    this.centerChanged.emit(this.googleMap.getCenter());
  }

  public onMapClicked(event: any) {
    const latLng = new google.maps.LatLng(event.latLng.lat(), event.latLng.lng());
    this.mapClicked.emit(latLng);
  }

  public onMarkerMouseOver(marker: GoogleMapMarker.MapMarker, info: string) {
    if (info) {
      this.infoContent = info;
      this.infoWindow.open(marker);
    }
  }
}
